import * as PATHS from 'constants/app-paths'

export const PRODUCTS_SUBMENU = [
  {
    label: 'Produtos',
    link: PATHS.PRODUCTS,
  },
  {
    label: 'Entrada/Saída',
    link: PATHS.STOCK_ACTIVITY,
  },
  {
    label: 'Preços',
    link: PATHS.PRODUCT_PRICES,
  },
  {
    label: 'Fabricantes',
    link: PATHS.MANUFACTURERS,
  },
  {
    label: 'Categorias',
    link: PATHS.PRODUCT_CATEGORIES,
  },
  {
    label: 'Grupos',
    link: PATHS.PRODUCT_GROUPS,
  },
]

export const CUSTOMERS_SUBMENU = [
  {
    label: 'Clientes',
    link: PATHS.CUSTOMERS,
  },
]

export const SALES_SUBMENU = [
  {
    label: 'Pedidos',
    link: PATHS.ORDERS,
  },
]

export const SETTINGS_SUBMENU = [
  {
    label: 'Canais de venda',
    link: PATHS.SALES_CHANNELS,
  },
  {
    label: 'Formas de pagamento',
    link: PATHS.PAYMENT_METHODS,
  },
  {
    label: 'Resumo Diário',
    link: PATHS.REPORT_DAILY,
  },
  {
    label: 'Relatório de Recebimentos',
    link: PATHS.RECEIPT_REPORT,
  },
  {
    label: 'Relatório de Clientes',
    link: PATHS.ANALYTICS_CUSTOMERS,
  },
]
